export const TREATMENT_TO_LOCATIONS = {
  'LASIK': [
    'Albany',
    'Beverly Hills',
    'Camarillo',
    'Camarillo - Miramar LASIK Center',
    'Castro Valley',
    'Citrus Valley',
    'Clairemont/San Diego',
    'Concord',
    'Coronado',
    'Corvallis',
    'Covina',
    'Downtown Los Angeles',
    'Midtown Sacramento',
    'Filutowski Eye Institute - Orlando',
    'Filutowski Eye Institute - Lake Mary',
    'Filutowski Eye Institute - Daytona Beach',
    'Fullerton',
    'Fullerton - Winston Eye Care',
    'Gardena',
    'Huntington Beach',
    'La Jolla',
    'La Mesa',
    'Laguna Hills',
    'Las Vegas Alta Rose',
    'Las Vegas Cheyenne',
    'Las Vegas Flamingo',
    'Lebanon',
    'Lincoln City',
    'Mission Viejo',
    'Murrieta',
    'Newport Beach',
    'North Sacramento - Royo Eye',
    'Ontario',
    'Oxnard',
    'Roseburg',
    'Roseville',
    'Roseville - Royo Eye',
    'Rowland Heights',
    'Sacramento',
    'San Diego Eye & Laser Center',
    'San Leandro',
    'San Pedro',
    'Santa Ana',
    'Santa Paula',
    'Sherwood',
    'South Sacramento - Royo Eye',
    'Thousand Oaks',
    'Tigard',
    'Torrance',
    'Torrance - East West Eye',
    'Tucson',
    'Ventura',
    'West Los Angeles',
    'San Antonio - North Central',
    'San Antonio - Medical Center',
    'San Antonio - South',
    'Seguin',
    'New Braunfels',
    'Gonzales',
    'San Marcos',
    'La Vernia',
    'Hondo',
    'Castroville',
    'Westlake Eye Surgery Center',
    'Encinitas',
    'Vista',
    'San Jose',

    // Affiliates
    'Aff-Goel Vision',
    'Aff-Katzen Eye Group',
    'Aff-EDOW',
    'Aff-Durrie Vision',
    'Aff-Boston Vision',
    'Aff-Pamel Vision',
    'Aff-Vision for Life',
    'Aff-Florida Vision',
    'Aff-Price Vision',
    'Aff-Michigan Ophthalmology',
    'Aff-Diamond Vision Atlanta',
    'Aff-Diamond Vision Paramus',
    'Aff-Diamond Vision Manhattan',
    'Aff-Pamel Vision Astoria',
    'Aff-Herschel LASIK',
    'Aff-Florida Vision Port St Lucie',
    'Aff-Kraff Eye',
    'Aff-Washington University',
    'Aff-Lasik Vision Centers Cleveland',
    // 'Aff-SharpeVision',
    'Aff-Center for Excellence in Eye Care',
    'Aff-Atwal Eye Care',
    'Aff-Siepser Eyecare',
    // 'Aff-SharpeVision Chicago',
    'Salem',
    'Aff-Southwest Eye Care',
    'Aff-Milwaukee Eye Surgeons',
    'Aff-Rochester Eye and Laser Center',
    'Aff-Advanced LASIK',
    'Aff-Eye Consultants',
    'Aff-Beach Eye Care',
    'Aff-Kugler Vision',
    'Aff-Toyos Clinic Nashville',
    'Aff-Toyos Clinic Memphis',
    'Aff-Michelson Laser Vision',
    'Aff-Florida Vision Port St Lucie 2',
    'Aff-Florida Vision Jupiter',
    'Aff-Triangle Eye Consultants',
    'Aff-ICON Eyecare Denver',
    'Aff-ICON Eyecare Golden',
    'Aff-ICON Eyecare Lone Tree',
    'Aff-Beach Eye Kempsville',
    'Aff-Beach Eye Chesapeake',
    'Aff-Pannu Laser & Vision Boca Raton',
    'Aff-Pannu Laser & Vision Davie',
    'Aff-Advanced LASIK Pasadena',
    'Aff-Advanced LASIK CT',
    'Aff-Boulder Eye Surgeons',
    'Aff-Denver Eye Surgeons',
    'Aff-Eye Center of Northern Colorado',
  ],
  'Cataract Surgery': [
    'Albany',
    'Beverly Hills',
    'Camarillo',
    'Camarillo - Miramar LASIK Center',
    'Citrus Valley',
    'Clairemont/San Diego',
    'Concord',
    'Coronado',
    'Corvallis',
    'Covina',
    'Downtown Los Angeles',
    'Midtown Sacramento',
    'Fullerton',
    'Fullerton - Winston Eye Care',
    'Gardena',
    'Huntington Beach',
    'La Jolla',
    'La Mesa',
    'Laguna Hills',
    'Las Vegas Alta Rose',
    'Las Vegas Cheyenne',
    'Las Vegas Flamingo',
    'Lebanon',
    'Lincoln City',
    'Mission Viejo',
    'Murrieta',
    'Newport Beach',
    'North Sacramento - Royo Eye',
    'Ontario',
    'Oxnard',
    'Roseburg',
    'Roseville',
    'Roseville - Royo Eye',
    'Rowland Heights',
    'Sacramento',
    'San Diego Eye & Laser Center',
    'San Leandro',
    'San Pedro',
    'Santa Ana',
    'Santa Paula',
    'Sherwood',
    'South Sacramento - Royo Eye',
    'Thousand Oaks',
    'Tigard',
    'Torrance',
    'Torrance - East West Eye',
    'Tucson',
    'Tucson-Catalina Eye',
    'Ventura',
    'West Los Angeles',
    'San Antonio - North Central',
    'San Antonio - Medical Center',
    'San Antonio - South',
    'Seguin',
    'New Braunfels',
    'Gonzales',
    'San Marcos',
    'La Vernia',
    'Hondo',
    'Castroville',
    'Westlake Eye Surgery Center',
    'Westlake Village Eyecare',
    'Salem',
    'Corpus Christi',
    'Encinitas',
    'Vista',
    'San Jose',

    // Affiliates
    'Aff-Siepser Eyecare',
  ],
  'Glaucoma': [
    'Newport Beach',
    'Ontario',
    'Murrieta',
    'Fullerton',
    'Laguna Hills',
    'Torrance - East West Eye',
    'Gardena',
    'Huntington Beach',
    'Camarillo - Miramar LASIK Center',
    'Camarillo',
    'Ventura',
    'Oxnard',
    'Santa Paula',
    'Thousand Oaks',
    'Coronado',
    'La Mesa',
    'Clairemont/San Diego',
    'San Diego Eye & Laser Center',
    'Encinitas',
    'North Sacramento - Royo Eye',
    'South Sacramento - Royo Eye',
    'San Antonio - North Central',
    'San Antonio - Medical Center',
    'San Antonio - South',
    'Seguin',
    'New Braunfels',
    'Gonzales',
    'San Marcos',
    'La Vernia',
    'Hondo',
    'Castroville',
    'Tucson'
  ],
  'Corneal Cross-Linking': [
    'Clairemont/San Diego',
    'Concord',
    'Fullerton',
    'La Jolla',
    'Laguna Hills',
    'Las Vegas Cheyenne',
    'Las Vegas Flamingo',
    'Lebanon',
    'Murrieta',
    'Newport Beach',
    'North Sacramento - Royo Eye',
    'San Leandro',
    'Ontario',
    'Oxnard',
    'Roseville',
    'Roseville - Royo Eye',
    'Rowland Heights',
    'Sacramento',
    'Santa Paula',
    'South Sacramento - Royo Eye',
    'Torrance',
    'Ventura',
    'Aff-ICON Eyecare Denver',
    'Aff-ICON Eyecare Golden',
    'Aff-ICON Eyecare Lone Tree',
  ],
  'Other': [
    'Abstracting/Legacy',
    'Employee Referral',
    'NVISION Employee',
    'Open Access',
    'Walk in',
  ],
};

export const LEAD_TYPE_1_TO_ATTRIBUTION = {
  Alumni: ['Alumni', 'Guarantor'],
  'Manufacturer Marketing': ['Acufocus Lead', 'Visian ICL'],
  'Direct to Consumer (DTC)': [
    'Consumer Event/Open House',
    'display',
    'Direct',
    'email',
    'LCA Lead Program',
    'Online Directory',
    'organic',
    'Paid',
    'Print',
    'social',
    'TV/Radio',
    'website',
    'Other',
  ],
  'Eye Care Professional (ECP) Referral': [
    'Consult Request Form',
    'Family Physician (MD) Referral Phone Call',
    'LASIK Consult (RLC) Event at OD Office',
    'Optometrist (OD) Referral Phone Call',
    'OD Website',
  ],
  'Primary Care Physician (PCP) Referral': ['TM Referral Form', 'MD Script'],
  'Third Party Payer (TPP)/Corporate Partnership (Corp)': [
    'AETNA',
    'ANTHAM SPECIAL OFFERS',
    'CAREINGTON',
    'CIGNA',
    'DAVIS VISION',
    'Eye Benefits',
    'EYEMED VISION CARE',
    'Human Lifestyle',
    'MES Vision',
    'OPTUM HEALTH',
    'Other TPP',
    'PRINCIPAL',
    'QualSight',
    'SPECTERA',
    'UnitedHealth Care',
    'VSP',
    'Other',
  ],
  Other: [
    'Abstracting/Legacy',
    'Employee Referral',
    'NVISION Employee',
    'Open Access',
    'Walk in',
    'Other',
  ],
};

export const LEAD_TYPE_2_TO_ATTRIBUTION = {
  Alumni: ['Alumni', 'Guarantor'],
  'Manufacturer Marketing': ['Acufocus Lead', 'Manufacturing (Closed)', 'Visian ICL'],
  'Direct to Consumer (DTC)': [
    'Consumer Event/Open House',
    'cpc',
    'display',
    'email',
    'LCA Lead Program',
    'Online Directory',
    'Paid',
    'Print',
    'social',
    'TV/Radio',
    'website',
  ],
  'Eye Care Professional (ECP) Referral': [
    'Consult Request Form',
    'Family Physician (MD) Referral Phone Call',
    'LASIK Consult (RLC) Event at OD Office',
    'Optometrist (OD) Referral Phone Call',
    'OD Website',
  ],
  'Primary Care Physician (PCP) Referral': ['TM Referral Form', 'MD Script'],
  'Third Party Payer (TPP)/Corporate Partnership (Corp)': [
    'AETNA',
    'ANTHAM SPECIAL OFFERS',
    'CAREINGTON',
    'CIGNA',
    'DAVIS VISION',
    'Eye Benefits',
    'EYEMED VISION CARE',
    'Human Lifestyle',
    'MES Vision',
    'OPTUM HEALTH',
    'Other TPP',
    'PRINCIPAL',
    'QualSight',
    'SPECTERA',
    'UnitedHealth Care',
    'VSP',
  ],
  Other: [
    'Abstracting/Legacy',
    'Employee Referral',
    'NVISION Employee',
    'Open Access',
    'Walk in',
  ],
};

export const LASIK_LINKS = {
  'Laguna Hills': 'https://www.smilereminder.com/sr/schedule/anon.do?id=16e7cb686e0ad1c2',
  'Fullerton': 'https://www.smilereminder.com/sr/schedule/anon.do?id=948d6fa76204d56b',
  'La Jolla': 'https://www.smilereminder.com/sr/schedule/anon.do?id=a00f7b21ff8bc06c',
  'Newport Beach': 'https://www.smilereminder.com/sr/schedule/anon.do?id=c93a10144c50728d',
  'Ontario': 'https://www.smilereminder.com/sr/schedule/anon.do?id=a387cd72223812f0',
  'Roseville': 'https://www.smilereminder.com/sr/schedule/anon.do?id=5a81f154e7dfaebe',
  'Las Vegas Cheyenne': 'https://www.smilereminder.com/sr/schedule/anon.do?id=5cd7b08fd5c0371f',
  'Las Vegas Flamingo': 'https://www.smilereminder.com/sr/schedule/anon.do?id=4dc85089986c3eba',
};
